import {NewProductCardFormField} from "../types/product-card.types";
import {resources} from "../../../../models/resource/resources";

export const productCardModalName = 'product-card';
export const productCardResourceType = resources['product-cards'];

export const newProductCardFormFields: Array<NewProductCardFormField> = [
  {
    label: 'Артикул',
    fieldName: 'article',
    isReadonly: true,
    isVisible: true
  },
  {
    label: 'Наименование',
    fieldName: 'title',
    isVisible: true
  },
  {
    label: 'articleId',
    fieldName: 'articleId'
  },
]
